<template>
	<div>
		<el-card shadow="never">
			<div slot="header" class="clearfix">
				<h4>基本信息</h4>
			</div>
			<el-form :model="addBody" :rules="rules" ref="addBody" label-width="100px" class="demo-addBody">
				<el-form-item label="角色名称" prop="name" :label-width="labelWidth">
					<el-input style="width: 400px;" v-model="addBody.name"
						placeholder="请输入1-10位角色名称，仅支持字母/汉字/数字"></el-input>
				</el-form-item>
			</el-form>
		</el-card>
		<el-card shadow="never" style="margin-top: 20px;">
			<div slot="header" class="clearfix">
				<h4>角色权限</h4>
			</div>
			<el-tree @check-change='menusChange' :data="doubaoList" show-checkbox node-key="id"
				:default-expand-all='true' :default-checked-keys="addBody.menus" :props="defaultProps">
			</el-tree>
		</el-card>
		<el-card shadow="never" style="margin-top: 10px;" class="flex flex-c">
			<el-button type="primary" style="width: 150px;" plain @click="resetForm('addBody')">返回</el-button>
			<el-button type="primary" style="width: 150px;" @click="submitForm('addBody')">保存</el-button>
		</el-card>


	</div>
</template>

<script>
	import {
		imgDomain
	} from '@/configs/env';
	import operations from "@/mixins/operations";
	import {
		getUser,
		addAdminRole,
		updateAdminRole,
		getAdminMenu,
		getAdminRoleDetail
	} from "@/api/auth"
	import {
		mapState
	} from "vuex";

	export default {
		name: "userDetail",
		mixins: [operations],
		data() {
			return {
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				labelWidth: '150px',
				imgDomain,
				doubaoList: [],
				num: 1,
				detailObject: {},
				detailUserId: '',
				user_uuid: '',
				addBody: {
					name: '',
					menus: [],
					uuid:''
				},
				rules: {
					name: [{
							required: true,
							message: '请输入角色名称',
							trigger: 'blur'
						},
						{
							min: 1,
							max: 10,
							message: '长度在 1 到 10 个字符',
							trigger: 'blur'
						}
					],
				},
				isEdit: false
			};
		},
		components: {},
		async mounted() {
			const uuid = this.$route.query.uuid
			this.user_uuid = uuid
			this.getAdminMenu()
			if (uuid) {
				this.addBody.uuid = uuid
				this.isEdit = true
				this.getAdminRoleDetail(uuid);
			}
		},
		methods: {
			menusChange(e) {
				this.addBody.menus.push(e.id)
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.isEdit) {
							this.editUser()
						} else {
							this.addAdminUser()
						}
					} else {
						return false;
					}
					return false
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
				this.goBack()
			},
			async getAdminMenu() {
				let postData = {
					page_size: 999,
					page_index: 1,
				};
				const {
					status,
					data
				} = await getAdminMenu(postData);
				if (status !== 200) return;
				let arrs = data.result.data
				let treeList = []
				arrs.forEach(item => {
					let childs = []
					item.child.forEach(_item => {
						let child1 = []
						_item.child.forEach(item1=>{
							let objChild1 = {
								id: item1.uuid,
								label: item1.name,
							}
							child1.push(objChild1)
						})
						let objChild = {
							id: _item.uuid,
							label: _item.name,
							children: child1
						}
						childs.push(objChild)
					})
					let obj = {
						id: item.uuid,
						label: item.name,
						children: childs
					}
					treeList.push(obj)
				})
				this.doubaoList = treeList
				this.total = data.result.total;
			},
			goBack() {
				this.$router.go(-1)
			},
			async getAdminRoleDetail(uuid) {
				const {
					data,
					status
				} = await getAdminRoleDetail({
					uuid: uuid
				});
				if (status === 200) {
					this.addBody.name = data.result.name
					this.addBody.menus = data.result.menus
				}
			},
			async addAdminUser() {
				const {
					status,
					data
				} = await addAdminRole({
					...this.addBody
				})
				if (status !== 200) return
				this.dialog = false
				this.$message.success('新增成功')
				setTimeout(() => {
					this.goBack()
				}, 500)
			},
			async editUser() {
				const {
					status
				} = await updateAdminRole({
					...this.addBody
				})
				if (status !== 200) return
				this.dialog = false
				this.$message.success('修改成功')
				setTimeout(() => {
					this.goBack()
				}, 500)
			},

		}
	};
</script>

<style lang="less" scoped>
	.titles {
		color: #000;
		font-size: 20px;
	}

	.subtitle {
		color: #000;
		font-size: 18px;
		margin-bottom: 30px;
	}

	.el-icon-back {
		font-size: 22px !important;
		cursor: pointer;
	}

	.leftbg {
		display: flex;
		align-items: center;
	}

	.ava {
		width: 88px;
		height: 88px;
		border-radius: 50%;
		margin-right: 30px;
	}

	.lefttitle {
		font-size: 16px;
		color: #999;
		margin-bottom: 20px;
	}

	.leftval {
		margin-bottom: 20px;
		font-size: 16px;
		color: #000;
	}

	.imgsList {
		display: flex;
		align-items: center;
		flex-wrap: wrap;

		.imgItem {
			width: 32%;
			margin-right: 20px;
			margin-bottom: 20px;
		}
	}

	.operation-item {
		color: #409EFF;
		cursor: pointer;
		justify-content: center;
	}
</style>